/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721Adapter,
  ERC721AdapterInterface,
} from "../../../contracts/adapters/ERC721Adapter";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "AmountOrIDInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes4",
            name: "kind",
            type: "bytes4",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct Party",
        name: "party",
        type: "tuple",
      },
    ],
    name: "hasAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes4",
            name: "kind",
            type: "bytes4",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct Party",
        name: "party",
        type: "tuple",
      },
    ],
    name: "hasBalance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "wallet",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes4",
            name: "kind",
            type: "bytes4",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct Party",
        name: "party",
        type: "tuple",
      },
    ],
    name: "hasValidParams",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "interfaceId",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ERC721AdapterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721AdapterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721Adapter__factory extends ContractFactory {
  constructor(...args: ERC721AdapterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<ERC721Adapter> {
    return super.deploy(overrides || {}) as Promise<ERC721Adapter>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ERC721Adapter {
    return super.attach(address) as ERC721Adapter;
  }
  override connect(signer: Signer): ERC721Adapter__factory {
    return super.connect(signer) as ERC721Adapter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721AdapterInterface {
    return new utils.Interface(_abi) as ERC721AdapterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721Adapter {
    return new Contract(address, _abi, signerOrProvider) as ERC721Adapter;
  }
}
